import { takeLatest, put, call, select } from 'redux-saga/effects';
import { REPAY_MONEY_FOR_SUBSCRIPTION_SAGA } from "../sagaTypes";
import { loaderAction, repayMoneyFormAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { getSubscriptionsSagaAction, getUserInfoSagaAction } from "../sagaActions";

const request = data => {
    return fetch(`${ url }/repay_money_for_subscription`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerRepayMoneyForSubscription(args) {
    const user = yield select(state => state.user);
    const currentUser = yield select(state => state.currentUser);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('subscription_id', args.data.subscription_id);
        formData.append('sum', args.data.sum);
        formData.append('payment_method', args.data.payment_method || '');

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Закрываем форму возврата средств
            yield put(repayMoneyFormAction({
                open: false,
                subscription_id: '',
                sum: '',
                payment_method: { id: '', name: '' }
            }));
            // Если возвращали средства со страницы пользователя
            if (currentUser.id) {
                // Получаем информацию о пользователе (с абонементами)
                yield put(getUserInfoSagaAction({ id: currentUser.id }));
            }
            // Если возвращали деньги со страницы с абонементами
            else {
                // Получаем список абонементов
                yield put(getSubscriptionsSagaAction());
            }
            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherRepayMoneyForSubscription() {
    yield takeLatest(REPAY_MONEY_FOR_SUBSCRIPTION_SAGA, workerRepayMoneyForSubscription);
}